import axios from 'axios'

export default axios.create({
  baseURL: 'https://imcmexico.mx/'
  // baseURL: 'http://localhost/imcmexico-backend/server/index.php'
})